import React from "react";
import { liheart } from "../../../assets/icons";
import { PublicService } from "../../../services";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import {
  postpartumBannerLeft,
  postpartumBannerRight,
} from "../../../assets/images";
import FAQ from "../../home/section/FAQ";
import { Helmet } from "react-helmet";

const Postpartum = ({ type }) => {
  const schemaData =  {
 "@context": "https://schema.org",
 "@graph": [
   {
     "@type": "MedicalCondition",
     "name": "Postpartum",
     "alternateName": "Postpartum Recovery",
     "description": "Postpartum recovery is more than physical healing; it's about regaining strength, hormonal balance, and emotional well-being. With Holypills, women can manage this phase naturally through homeopathy and personalized app-based support.",
     "url": "https://holypills.in/postpartum-symptoms-causes-treatment",
     "mainEntityOfPage": "https://holypills.in/postpartum-symptoms-causes-treatment",
     "associatedAnatomy": {
       "@type": "AnatomicalStructure",
       "name": "Female Reproductive System"
     },
     "possibleTreatment": {
       "@type": "MedicalTherapy",
       "name": "Homeopathy"
     },
     "signOrSymptom": [
       { "@type": "MedicalSignOrSymptom", "name": "Postpartum bleeding (lochia)" },
       { "@type": "MedicalSignOrSymptom", "name": "Fatigue and body aches" },
       { "@type": "MedicalSignOrSymptom", "name": "Hormonal mood swings" },
       { "@type": "MedicalSignOrSymptom", "name": "Breast engorgement or discomfort" },
       { "@type": "MedicalSignOrSymptom", "name": "Vaginal soreness, discomfort, or perineal pain" },
       { "@type": "MedicalSignOrSymptom", "name": "Sleep disturbances and night sweats" },
       { "@type": "MedicalSignOrSymptom", "name": "Hair loss and skin changes" },
       { "@type": "MedicalSignOrSymptom", "name": "Mild anxiety and ‘baby blues" }
     ]
   }
 ]
};


  const faqData =  {
 "@context": "https://schema.org",
 "@type": "FAQPage",
 "mainEntity": [{
   "@type": "Question",
   "name": "What is normal after birth, and when to see a doctor?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Mild bleeding, cramping, fatigue, and mood changes are common after delivery. However, if you notice heavy bleeding, high fever, severe pain, or persistent sadness, consult a doctor immediately. Using homeopathy for postnatal care can support natural recovery and reduce complications."
   }
 },{
   "@type": "Question",
   "name": "Is homeopathy safe while breastfeeding?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Yes, homeopathic treatment after delivery is generally considered safe during breastfeeding, as remedies are natural, gentle, and non-toxic. Many mothers choose natural homeopathy for postpartum healing to manage fatigue, anxiety, and hormonal changes without affecting breast milk quality."
   }
 },{
   "@type": "Question",
   "name": "How long should I use the app daily?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Just a few minutes each day. Logging your physical and emotional symptoms in the Holypills app creates auto-reports that help both you and your doctor monitor necessary. This makes postpartum anxiety homeopathy treatment and other personalized care more effective, without taking up much of your time."
   }
 },{
   "@type": "Question",
   "name": "Can postpartum depression be managed with homeopathy/app support?",
   "acceptedAnswer": {
     "@type": "Answer",
     "text": "Yes. While medical guidance is essential, combining homeopathy for postpartum depression with app-based tracking offers strong support. Homeopathic remedies for postpartum depression can ease the mood swings, anxiety, and sleep issues."
   }
   }
 ]
};



  const { healthPage } = PublicService();

  const pcosQuery = useQuery({
    queryKey: ["postpartum"],
    queryFn: () => healthPage({ category: "postpartum" }),
  });

  const detail = pcosQuery?.data?.data?.content;

  return (
    <>
      <Helmet defer={false}>
        <title>
          Postpartum Care with Holypills: Recover Naturally with Homeopathy
        </title>
        <meta
          name="description"
          content="Postpartum care with Holypills combines natural homeopathy and app-based tracking to support recovery, balance hormones, and restore energy safely."
        />
        <meta property="og:image" content="/src/assets/images/ogImage.jpg" />
        <meta name="twitter:image" content="/src/assets/images/ogImage.jpg" />
        <link
          rel="canonical"
          href="https://holypills.in/postpartum-symptoms-causes-treatment"
        ></link>
        <meta property="og:type" content="article" />
        <meta
          property="og:title"
          content="Postpartum Care with Holypills: Recover Naturally with Homeopathy"
        />
        <meta
          property="og:description"
          content="Postpartum care with Holypills combines natural homeopathy and app-based tracking to support recovery, balance hormones, and restore energy safely."
        />
        <meta
          property="og:url"
          content="https://holypills.in/postpartum-symptoms-causes-treatment"
        />
        <meta property="og:site_name" content="Holypills"></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Postpartum Care with Holypills: Recover Naturally with Homeopathy"
        />
        <meta
          name="twitter:description"
          content="Postpartum care with Holypills combines natural homeopathy and app-based tracking to support recovery, balance hormones, and restore energy safely."
        />
        <meta
          name="twitter:url"
          content="https://holypills.in/postpartum-symptoms-causes-treatment"
        ></meta>
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
        <script type="application/ld+json">{JSON.stringify(faqData)}</script>
        {/* <script type="application/ld+json">
          {JSON.stringify(orgnaizationData)}
        </script> */}
      </Helmet>

      <div className="wrapper_pcos_page postpartum">
        {/* <section className="wrap_pcos_banner">
        <figure>
          <img src={detail?.banner?.image} alt="" />
        </figure>
      </section> */}

        <section className="banner_sec">
          <div className="container">
            <div className="inner_part">
              <div className="left_part">
                <div className="left_image">
                  <figure>
                    <img src={postpartumBannerLeft} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="right_part">
                <div className="right_img">
                  <figure>
                    <img src={postpartumBannerRight} alt="banner-image" />
                  </figure>
                </div>
              </div>
              <div className="banner_content">
                <h1>
                  Postpartum Recovery with Holypills{" "}
                  <span>Embrace Natural Healing Through Homeopathy</span>
                </h1>
                <p>
                  Postpartum recovery is more than physical healing; it's about
                  regaining strength, hormonal balance, and emotional
                  well-being. With Holypills, women can manage this phase
                  naturally through homeopathy and personalized app-based
                  support.
                </p>
                {/* <div className="btn-box">
                  <Link to="/login" className="button blue">
                    Start Your Healing Journey
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.whatIsSection?.title}</h2>
                <p>{detail?.whatIsSection?.description}</p>
                <ul>
                  {detail?.whatIsSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.whatIsSection?.image} alt="section-image" />
                </figure>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.commonSigns?.title}</h2>
                <p>{detail?.commonSigns?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.commonSigns?.signs.map((item, index) => (
                  <button key={index} className={index === 1 ? "" : ""}>
                    {item}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_what_cause spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_right">
                <figure>
                  <img src={detail?.causesSection?.image} alt="causes-image" />
                </figure>
              </div>
              <div className="wrap_left">
                <h2>{detail?.causesSection?.title}</h2>
                <p>{detail?.causesSection?.description}</p>
                {/* <p>
                Polycystic ovary syndrome (PCOS) is a problem with hormones that
                happens during the reproductive years. If you have PCOS, you may
                not have periods very often. Or you may have periods that last
                many days. You may also have too much of a hormone called
                androgen in your body.
              </p>
              <p>
                With PCOS, many small sacs of fluid develop along the outer edge
                of the ovary. These are called cysts. The small fluid-filled
                cysts contain immature eggs, called follicles. The follicles
                fail to regularly release eggs.
              </p> */}
                <ul>
                  {detail?.causesSection?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <div className="wrap_txt">
                        <p>{item?.title}</p>
                        <span>{item?.description}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_Symptoms wrapper_help spacing">
          <div className="container">
            <div className="wrap_symptoms_card">
              <div className="page_title">
                <h2>{detail?.howToManage?.title}</h2>
                <p>{detail?.howToManage?.description}</p>
              </div>
              <div className="wrap_btn_card">
                {detail?.howToManage?.features.map((item, index) => (
                  <button key={index}>
                    <img src={item?.image} alt="image" />
                    <span>{item.title}</span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </section>
        <section className="wrapper_pcos wrapper_pcos_system spacing">
          <div className="container">
            <div className="wraper_cards">
              <div className="wrap_left">
                <h2>{detail?.howToReduce?.title}</h2>
                <p>{detail?.howToReduce?.description}</p>
                <ul>
                  {detail?.howToReduce?.benifits.map((item, index) => (
                    <li key={index}>
                      <img src={liheart} alt="heart-icon" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="wrap_right">
                <figure>
                  <img src={detail?.howToReduce?.image} alt="reduce-image" />
                </figure>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="expert_sec">
          <div className="container">
            <div className="page_title">
              <h2>Download The App To Reduce Postpartum Symptoms</h2>
              <div className="btn-box">
                <Link to="/login" className="button blue">
                  Download the app
                </Link>
              </div>
            </div>
          </div>
        </section> */}

        {/* FAQ */}
        <FAQ type={"postpartum"} />
      </div>
    </>
  );
};

export default Postpartum;
